<script>
// Probably a premature optimization to make this a functional component,
// but it's literally just an <img/> tag. No need for a vue instance...
import * as utils from '@/utils'

const getSrc = emojiOrEmoteId => {
    let url = utils.twemojiToUrl(emojiOrEmoteId)
    // Falsy url means twemoji failed to parse, and the arg is likely
    // a BTTV emote.
    if (!url) {
        url = utils.bttvEmoteIdToUrl(emojiOrEmoteId)
    }
    return url
}

// TODO: Will bypassing vue and mutating the DOM cause any problems?
const fallbackImg = utils.twemojiToUrl('🚫')
const onError = e => {
    const $img = e.target
    // Stop infinite loop if fallbackImg errors!!
    if ($img.src === fallbackImg) { return }

    $img.src = fallbackImg
}

export default {
    functional: true,
    props: {
        emote: {
            type: String,
            required: true,
        },
        alias: String,
        size: Number,
        responsive: Boolean,
        lazyLoad: {
            type: Boolean,
            default: false
        },
    },
    render (h, ctx) {
        const { props, data } = ctx
        const { emote, alias, size, responsive, lazyLoad } = props
        const src = getSrc(emote)

        let divStyle = {}
        let imgAttrs = {}
        const loading = lazyLoad ? 'lazy' : 'auto'

        let classes = 'emote'
        if (responsive) {
            classes += ' responsive'
        } else if (size) {
            // if lazyLoading=true, width/height must be specified as <img/>
            // attributes, to satisfy chrome warnings wrt lazy loading.
            if (lazyLoad) {
                imgAttrs = {
                    width: size,
                    height: size,
                }
            } else {
                // Use style to override the default CSS.
                divStyle = {
                    width: `${size}px`,
                    height: 'auto',
                    maxHeight: `${size}px`
                }
            }
        }

        return (
            <div class={classes} style={divStyle} {...data}>
                <img
                    src={src}
                    alt={alias}
                    emote-alias={alias}
                    draggable="false"
                    vOn:error={onError}
                    loading={loading}
                    {...{ attrs: imgAttrs }}/>
            </div>
        )
    }
}
</script>

<style lang="scss" scoped>
.emote {
    @include flex-center-children;
    width: $emote-size;
    height: $emote-size;
}
.emote.responsive {
    width: 100%;
    height: auto;
    max-height: 100%;
}
</style>
